module.exports = __webpack_public_path__ + "assets/img/button-loader-blue-dark.74290e8d.svg";